<template>
	<div id="app">
		<Header></Header>
		
		<router-view></router-view>
	</div>
</template>

<script>

import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import Header from './components/Header';

export default {
	name: 'app',
	components: {
		Header
	},
	data() {
		return {
			loading: false
		}
	},
	beforeMount() {
		this.loading = true;
		axios({
			method: 'GET',
			url: '/server/login.php?action=checklogin',
			data: {}
		}).then((response) => {
			if(response.data.error != 0){
				/*this.$notify.error({
					title: 'Error',
					message: response.data.message,
					offset: 115
				});*/
			} else {
				this.login({username: response.data.user.username, img: ''});
			}
		})
		.catch(this.catchAxios)
		.then(() => {
			this.loading = false;
		});
		this.$router.afterEach((to, from) => {
			this.checkRoute(to, from);
		})
		this.$router.beforeEach(this.checkRoute)
	},
	methods: {
		...mapActions([
			'login'
		]),
		checkRoute(to, from, next){
			if(to.meta.title != undefined && to.meta.title.trim() != ""){
				document.title = "League of Legends Argentina - " + to.meta.title;
			} else {
				document.title = "League of Legends Argentina";
			}

			if (to.meta.requiresAuth) {
				// this route requires auth, check if logged in
				// if not, redirect to login page.
				if (!this.logged) {
					if(next != undefined) {
						next({
							path: '/login',
							query: { redirect: to.fullPath }
						})
					} else {
						this.$router.push({
							path: '/login',
							query: { redirect: to.fullPath }
						});
					}
				} else {
					if(next != undefined) next()
				}
			} else {
				if(next != undefined) next() // make sure to always call next()!
			}

			//if(next != undefined) next();
		},
		catchAxios(error){
			console.log(error);
		}
	},
    computed: {
        // mix the getters into computed with object spread operator
        ...mapGetters([
			'username',
			'img',
			'logged'
			// ...
		])
    }
}
</script>

<style>
body {
	background-image: url('./assets/bg.jpg') !important;
	background-attachment: fixed;
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	margin: 0;
	/*color: #2c3e50;*/
	min-width: 850px;
	margin-top: 10px;
}

.el-input__inner {
	background-color: #222933cf !important;
}

.el-card {
	/*background-color: #22293373 !important;*/
	background-color: #222933CC !important;
}

.el-carousel__button {
	background-color: #fff !important;
}

.el-loading-mask {
	
    background-color: rgb(58 58 58 / 67%) !important;
}

.noselect {
	-webkit-touch-callout: none; /* iOS Safari */
	-webkit-user-select: none; /* Safari */
	-khtml-user-select: none; /* Konqueror HTML */
	-moz-user-select: none; /* Firefox */
	-ms-user-select: none; /* Internet Explorer/Edge */
	user-select: none; /* Non-prefixed version, currently
						supported by Chrome and Opera */
}

.clickeable {
	cursor: pointer;
}
</style>
